"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SbDynamicTabsContainer = void 0;

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _sbDynamicTabs = require("./sb-dynamic-tabs");

var _sbDynamicTabsActions = require("./sb-dynamic-tabs-actions");

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var _state$get;

  var namespace = ownProps.namespace;

  var _ref = ((_state$get = state.get) === null || _state$get === void 0 ? void 0 : _state$get.call(state, _constants.SB_DYNAMIC_TABS_STATE_KEY_NAME)) || state[_constants.SB_DYNAMIC_TABS_STATE_KEY_NAME],
      selectedTabs = _ref.selectedTabs;

  return {
    selectedTabId: selectedTabs ? selectedTabs[namespace] : null
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onChange: function onChange(tabId, namespace) {
      dispatch((0, _sbDynamicTabsActions.setSelectedTab)(_defineProperty({}, namespace, tabId)));
    }
  };
};

var SbDynamicTabsContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_sbDynamicTabs.SbDynamicTabs);
exports.SbDynamicTabsContainer = SbDynamicTabsContainer;
SbDynamicTabsContainer.propTypes = {
  namespace: _propTypes.default.string.isRequired
};
SbDynamicTabsContainer.displayName = 'SbDynamicTabsContainer';
//# sourceMappingURL=sb-dynamic-tabs-container.js.map